import { render, staticRenderFns } from "./ExcluirComprovante.vue?vue&type=template&id=a31b6bcc&"
import script from "./ExcluirComprovante.vue?vue&type=script&lang=ts&"
export * from "./ExcluirComprovante.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports